// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2D9Dk","inputWrap":"CustomTip_inputWrap__ry52q"};